// UploadFiles.js
class UploadFiles {
    constructor() {
        this.init();
    }

    init() {
        document.querySelectorAll('[data-upload-file-2]').forEach(el => {
            new UploadFilesElement(el);
        });
    }
}

class UploadFilesElement {
    constructor(root) {
        this.element = root;
        // Get the upload endpoint URL.
        this.uploadUrl = root.getAttribute('data-upload-file-2');

        // Parse initial file list from the data attribute.
        // Expected format: {'files': [{ id: 46, url: '/manager/image/46/', name: 'file.jpg', extension: 'image/jpeg' }]}
        const initRaw = root.getAttribute('data-upload-2-init') || '{}';
        try {
            this.initValues = JSON.parse(initRaw.replace(/'/g, '"'));
        } catch (e) {
            console.error('Error parsing data-upload-init-values:', e);
            this.initValues = {};
        }
        this.files = Array.isArray(this.initValues.files)
            ? this.initValues.files.map(file => {
                // If the file is not an object, treat it as a URL/id string.
                if (typeof file !== 'object' || file === null) {
                    return { id: file, url: file, name: file };
                }
                // If the file object does not have a name, try to extract it from the URL.
                if (!file.name && file.url) {
                    const parts = file.url.replace(/\/$/, '').split('/');
                    file.name = parts[parts.length - 1];
                }
                return file;
            })
            : [];

        this.setup();
    }

    setup() {
        // Ensure the root element has the required CSS class.
        this.element.classList.add('sk-upload-file');

        // Create a container for hidden inputs (each file gets one hidden input).
        this.hiddenInputContainer = document.createElement('div');
        this.hiddenInputContainer.style.display = 'none';
        this.element.appendChild(this.hiddenInputContainer);
        this.updateHiddenInputs();

        // Create a hidden file input for selecting files by click.
        this.fileInput = document.createElement('input');
        this.fileInput.type = 'file';
        this.fileInput.multiple = true;
        this.fileInput.style.display = 'none';
        this.fileInput.addEventListener('change', e => {
            this.handleFiles(e.target.files);
        });
        this.element.appendChild(this.fileInput);

        // Create the drop area element.
        this.dropArea = document.createElement('div');
        this.dropArea.className = 'sk-upload-drop-area';
        this.dropArea.innerHTML = '<p>Clique ou arraste os ficheiros para fazer o upload</p>';
        this.element.appendChild(this.dropArea);

        // Trigger file input on click.
        this.dropArea.addEventListener('click', () => {
            this.fileInput.click();
        });

        // Setup drag & drop events.
        this.dropArea.addEventListener('dragover', e => {
            e.preventDefault();
            this.dropArea.classList.add('dragover');
        });
        this.dropArea.addEventListener('dragleave', e => {
            e.preventDefault();
            this.dropArea.classList.remove('dragover');
        });
        this.dropArea.addEventListener('drop', e => {
            e.preventDefault();
            this.dropArea.classList.remove('dragover');
            this.handleFiles(e.dataTransfer.files);
        });

        // Create the table to list uploaded files.
        this.table = document.createElement('table');
        this.table.className = 'sk-upload-table';
        this.thead = document.createElement('thead');
        this.tbody = document.createElement('tbody');
        this.table.appendChild(this.thead);
        this.table.appendChild(this.tbody);
        this.element.appendChild(this.table);

        this.renderTableHeader();
        this.renderFiles();
    }

    renderTableHeader() {
        this.thead.innerHTML = '';
        const headerRow = document.createElement('tr');
        const thFile = document.createElement('th');
        thFile.textContent = 'Ficheiro';
        headerRow.appendChild(thFile);
        const thActions = document.createElement('th');
        thActions.textContent = '';
        headerRow.appendChild(thActions);
        this.thead.appendChild(headerRow);
    }

    handleFiles(fileList) {
        Array.from(fileList).forEach(file => {
            this.uploadFile(file);
        });
    }

    uploadFile(file) {
        const formData = new FormData();
        formData.append('file', file);

        fetch(this.uploadUrl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                // Expecting data to contain { id, name, extension, url }.
                if (data && data.id && data.url) {
                    this.files.push({
                        id: data.id,
                        url: data.url,
                        name: data.name,         // Returned file name
                        extension: data.extension // Returned file extension (MIME type)
                    });
                    this.updateHiddenInputs();
                    this.renderFiles();
                } else {
                    console.error('Unexpected response from upload endpoint:', data);
                }
            })
            .catch(error => {
                console.error('Error uploading file:', error);
            });
    }

    updateHiddenInputs() {
        // Clear any existing hidden inputs.
        this.hiddenInputContainer.innerHTML = '';
        // Create a hidden input for each file so PHP receives an array.
        this.files.forEach(file => {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'attachments[]';
            hiddenInput.value = file.id;
            this.hiddenInputContainer.appendChild(hiddenInput);
        });
    }

    renderFiles() {
        this.tbody.innerHTML = '';

        if (this.files.length === 0) {
            this.table.style.display = 'none';
            return;
        }
        this.table.style.display = 'table';

        this.files.forEach((file, index) => {
            const tr = document.createElement('tr');

            // File name column.
            const tdFile = document.createElement('td');
            tdFile.style.width = '100%';
            // Use the returned file name, or fallback to extracting it from the URL.
            const fileName = file.name || (() => {
                let temp = file.url;
                if (temp.endsWith('/')) {
                    temp = temp.slice(0, -1);
                }
                const parts = temp.split('/');
                return parts[parts.length - 1] || file.id;
            })();
            tdFile.textContent = fileName;
            tr.appendChild(tdFile);

            // Actions column.
            const tdActions = document.createElement('td');
            const divActions = document.createElement('div');
            divActions.style.display = 'flex';
            divActions.style.gap = '5px';
            divActions.style.alignItems = 'center';


            // Download link.
            const downloadLink = document.createElement('a');
            downloadLink.href = file.url;
            // downloadLink.download = fileName;
            downloadLink.target = '_blank';
            downloadLink.textContent = 'Download';
            downloadLink.style.marginRight = '8px';
            divActions.appendChild(downloadLink);

            // Remove button.
            const removeButton = document.createElement('button');
            removeButton.textContent = 'Remover';
            removeButton.addEventListener('click', () => {
                this.files.splice(index, 1);
                this.updateHiddenInputs();
                this.renderFiles();
            });
            divActions.appendChild(removeButton);
            tdActions.appendChild(divActions);

            tr.appendChild(tdActions);
            this.tbody.appendChild(tr);
        });
    }
}

export default UploadFiles;
